import { DateRange } from './date-range';
import { IndustryCategory } from './industry-category';
import { MinMaxRange } from './min-max-range';
import { TotalSKUSizeRange } from './total-sku-size';

export class SkuFilter {
    constructor(
        public attributeIds: Array<number> = [],
        public brandIds: Array<number> = [],
        public categoryIds: Array<number> = [],
        public countryIds: Array<number> = [],
        public industryCodes: Array<string> = [],
        public retailerIds: Array<number> = [],
        public skuIds: Array<number> = [],
        public emiItemIds: Array<number> = [],
        public supplierIds: Array<number> = [],
        public subBrandIds: Array<number> = [],
        public retailerTypeIds: Array<number> = [],
        public attributeGroupIds: Array<number> = [],
        public promotionTypeIds: Array<number> = [],
        public globalItemIds: Array<number> = [],
        public firstSeenPriceRange: MinMaxRange | null = null,
        public lastSeenPriceRange: MinMaxRange | null = null,
        public dateRange: DateRange | null = null,
        public volumeRange: TotalSKUSizeRange | null = null,
        public weightRange: TotalSKUSizeRange | null = null,
        public countRange: TotalSKUSizeRange | null = null
    ) {}
}
